import { useParams, useHistory } from "react-router-dom";
import { Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getCustomer } from "../../services";

//Components
import { Header } from "../../components";
import { NoClient } from "./NoClient";
import { MyClientProfile } from "./MyClientProfile";
import { flattenPlacesTree, getPlacesBreadcrumbBySystemId } from "../../utils";

export const ViewClient = () => {
  let params = useParams();
  let history = useHistory();

  const currentOrganization = useSelector(
    (state) => state.organization.currentOrganization
  );
  let appRole = currentOrganization?.app_role;
  const orgId = params?.orgId || currentOrganization?.id;
  const clientId = params?.id;

  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [currentClientData, setCurrentClientData] = useState();
  const [places, setPlaces] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  // get placeId based on history search
  const placeId = history?.location?.search?.split("=")[1];

  useEffect(() => {
    if (placeId) {
      const flattenedPlaces = flattenPlacesTree(places);
      const PlacesBreadcrumbBySystemI = getPlacesBreadcrumbBySystemId(
        flattenedPlaces,
        placeId
      );

      const breadcrumb = PlacesBreadcrumbBySystemI.map((place) => ({
        label: place.name,
        link: `/customers/${clientId}/${orgId}?place=${place.system_id}`,
      }));
      setBreadcrumbs([
        {
          label: "All Clients",
          link: `/customers`,
        },
        {
          label: currentClientData?.name,
          link: `/customers/${clientId}/${orgId}?place=overview`,
        },
        ...breadcrumb,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(places), history, placeId]);

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    setIsSuccess(false);
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  useEffect(() => {
    if (isSuccess) init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  async function init() {
    try {
      if (orgId && clientId) {
        let data = await getCustomer(orgId, clientId);
        setCurrentClientData(data);
        setBreadcrumbs([
          {
            label: "All Clients",
            link: `/customers`,
          },
          {
            label: data?.name,
            link: `/customers/${clientId}/${orgId}?place=overview`,
          },
        ]);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        name="View Client"
        history={history}
        breadcrumbs={breadcrumbs}
        noMargin
      />
      {!isLoading &&
      (currentClientData?.system_id === "undefined" ||
        !currentClientData?.system_id) ? (
        <NoClient />
      ) : (
        <>
          <MyClientProfile
            clientId={clientId}
            orgId={orgId}
            data={currentClientData}
            appRole={appRole}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
            setPlaces={setPlaces}
            places={places}
          />
        </>
      )}
    </Page>
  );
};
